import {
    FETCH_GROUPS_REQUEST,
    GET_GROUPS,
    GET_SINGLE_GROUP,
    GROUPS_ERROR,
    SET_CLICKED_GROUP,
} from '../ActionTypes';

const initialState = {
    groups: [],
    singleGroup: [],
    clickedGroup: '',
    newGroup: '',
    loading: true,
    error: '',
};

const groupReduction = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_GROUPS_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case GET_GROUPS:
            return {
                ...state,
                groups: action.payload,
                loading: false,
                error: '',
            };
        case GET_SINGLE_GROUP:
            return {
                ...state,
                singleGroup: action.payload,
                loading: false,
                error: '',
            };
        case SET_CLICKED_GROUP:
            return {
                ...state,
                clickedGroup: action.payload,
                loading: false,
                error: '',
            };
        case GROUPS_ERROR:
            return {
                ...state,
                groups: [],
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default groupReduction;
